import type { OwnerCollectionsPermissionsGroup } from 'src/hook/usePosts'
import { ManagerRoles } from 'src/hook/useUser/constants'
import { PermissionActions } from 'src/services/posts'
import { CommunityMemberPermissionsGroup } from 'src/services/community'
import { PERMISSIONS_ACTIONS } from './constant'
import { FilterPermissionParams, FilterPermissionsListByRolesParams } from './types'

export const filterPermissionsListByRoles = ({
  arrayPermissions,
  permissionsUserList
}: FilterPermissionsListByRolesParams) => {
  if (!arrayPermissions || !permissionsUserList) return null

  const result = arrayPermissions.map((permission) =>
    permissionsUserList.find((permissionUser) => permissionUser === permission)
  )

  return result.some((r) => r)
}

export const filterPermission = ({
  specificPermission,
  permissionsUserList
}: FilterPermissionParams) => {
  if (!permissionsUserList || !specificPermission) return null

  return permissionsUserList.some((permission) => permission === specificPermission)
}

export const isAuthorMemberTypeOwnerOrAdmin = (
  authorMemberType: OwnerCollectionsPermissionsGroup
) => {
  return [ManagerRoles.ADMIN, ManagerRoles.OWNER].some((role) => role === authorMemberType)
}

export const isUserModerator = (role: OwnerCollectionsPermissionsGroup) => {
  return role === ManagerRoles.MODERATOR
}

export const isUserAdmin = (role: OwnerCollectionsPermissionsGroup) => {
  return role === ManagerRoles.ADMIN
}

export const canUserBanMember = (permissionsUserList: PermissionActions[]) => {
  const arrayPermissions = [PERMISSIONS_ACTIONS.BLOCK_MEMBER_CREATE] as PermissionActions[]

  return filterPermissionsListByRoles({
    arrayPermissions,
    permissionsUserList
  })
}

export const canUserBanModerator = (permissionsUserList: PermissionActions[]) => {
  const arrayPermissions = [PERMISSIONS_ACTIONS.BLOCK_MODERATOR_CREATE] as PermissionActions[]

  return filterPermissionsListByRoles({
    arrayPermissions,
    permissionsUserList
  })
}

export const canUserBanAdmin = (permissionsUserList: PermissionActions[]) => {
  const arrayPermissions = [PERMISSIONS_ACTIONS.BLOCK_ADMIN_CREATE] as PermissionActions[]

  return filterPermissionsListByRoles({
    arrayPermissions,
    permissionsUserList
  })
}

export const canUserUnbanMember = (permissionsUserList: PermissionActions[]) => {
  const arrayPermissions = [PERMISSIONS_ACTIONS.BLOCK_DELETE] as PermissionActions[]

  return filterPermissionsListByRoles({
    arrayPermissions,
    permissionsUserList
  })
}

export const canUserDeletePost = (permissionsUserList: PermissionActions[]) => {
  const arrayPermissions = [PERMISSIONS_ACTIONS.POST_DELETE] as PermissionActions[]

  return filterPermissionsListByRoles({
    arrayPermissions,
    permissionsUserList
  })
}

export const canUserDeleteComment = (permissionsUserList: PermissionActions[]) => {
  const arrayPermissions = [PERMISSIONS_ACTIONS.COMMENT_DELETE] as PermissionActions[]

  return filterPermissionsListByRoles({
    arrayPermissions,
    permissionsUserList
  })
}

export const canUserSchedulePost = (permissionsUserList: PermissionActions[]) => {
  const arrayPermissions = [
    PERMISSIONS_ACTIONS.SCHEDULED_POST_CREATE,
    PERMISSIONS_ACTIONS.SCHEDULED_POST_DELETE,
    PERMISSIONS_ACTIONS.SCHEDULED_POST_READ
  ] as PermissionActions[]

  return filterPermissionsListByRoles({
    arrayPermissions,
    permissionsUserList
  })
}

export const isAdmin = (group?: CommunityMemberPermissionsGroup) =>
  [
    CommunityMemberPermissionsGroup.ADMIN,
    CommunityMemberPermissionsGroup.MODERATOR,
    CommunityMemberPermissionsGroup.OWNER
  ].includes(group as CommunityMemberPermissionsGroup)
